// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BkbgO","name":"Header_name__dSwOg","birthday":"Header_birthday__38cpi","skeleton":"Header_skeleton__3-8po"};